// @flow

const CSV_KEYS = [
  'vs', // venueServices
  'vt', // venueTypes
  'ne', // northEast
  'sw' // southWest
];

type FormattedPairs = { [string]: string | number, ... };
type SearchParams = { [string]: string | Array<number> | number, ... };

// Internal. Packs search keys to keys used in backend and joins arrays
// to comma separated strings
function packSearchPairs(searchPairs: SearchParams): FormattedPairs {
  const formattedPairs = {};

  Object.keys(searchPairs).forEach(key => {
    const pairValue = searchPairs[key];
    if (
      typeof pairValue === 'object' &&
      pairValue.length > 0 &&
      CSV_KEYS.indexOf(key) > -1
    ) {
      formattedPairs[key] = pairValue.join(',');
    } else if (typeof pairValue === 'number' && pairValue > 0) {
      formattedPairs[key] = pairValue;
    } else if (typeof pairValue === 'string' && pairValue.length > 0) {
      formattedPairs[key] = pairValue;
    }
  });

  return formattedPairs;
}

function unpackSearchPairs(packedSearchPairs: FormattedPairs): SearchParams {
  const unpackedPairs = {};

  Object.keys(packedSearchPairs).forEach(key => {
    const pairValue = packedSearchPairs[key];
    if (typeof pairValue === 'string' && CSV_KEYS.indexOf(key) > -1) {
      unpackedPairs[key] = pairValue.split(',').map(i => Number(i));
    } else {
      unpackedPairs[key] = pairValue;
    }
  });

  return unpackedPairs;
}

// Turns search values to a backend compatible hash object which can then be
// serialized to a string later if needed
const buildSearchParams = function (searchObj: SearchParams): FormattedPairs {
  const packedObj = packSearchPairs(searchObj);
  return packedObj;
};

const parseSearchParams = function (
  searchParams: FormattedPairs
): SearchParams {
  return unpackSearchPairs(searchParams);
};

export { buildSearchParams, parseSearchParams };
